<template>
    <div id="connectionContainer">
        <div v-show="!this.$store.state.loading && !this.$store.state.successful">
            <div class="connectionHeader">
                <div class="connectionInfo">
                    <p class="connectionInfoLine">
                        <span class="connectionInfoItem">広告クラスタ名 : </span>
                        <input class="adClusterInputText" type="text" v-model="adClusterName" />
                    </p>
                    <p class="connectionInfoLine">
                        <span class="connectionInfoItem">URL : </span>
                        <input class="adClusterInputText" type="text" v-model="adClusterUrl" />
                    </p>
                </div>
                <div class="info_icon">
                    <Tooltip direction="left" message="・ AM1:00に最新の按分率を引き継ぎます。<br>・ 新規設定の場合必ず全期間です。">
                        <Icon>information</Icon>
                    </Tooltip>
                </div>
                <a class="btn closeBtn" @click="$emit('modalClosed')">×</a>
            </div>

            <div class="dispRightMenu">
                <v-select class="select" name="hoge" :options="periodOptions" v-model="selectedPeriod"
                    :reduce="option => option.period"></v-select>
                <br>
                <span>期間：</span>
                <div v-if="selectedPeriod === 'allPeriod'">
                    <span>{{ productsAndRates.days.startday.getFullYear() + '-' +
                        (productsAndRates.days.startday.getMonth() + 1) + '-' +
                        (productsAndRates.days.startday.getDate()) }}</span>
                    <span>〜</span>
                    <span>{{ productsAndRates.days.endday.getFullYear() + '-' + (productsAndRates.days.endday.getMonth()
                        + 1) + '-' + (productsAndRates.days.endday.getDate()) }}</span>
                </div>
                <div v-else-if="selectedPeriod === 'pastPeriod'">
                    <Datepicker class="datepicker" format="yyyy-MM-dd" v-model="productsAndRates.days.startday"
                        :disabled-dates="disabledDates" :language="ja" placeholder="開始日" />
                    <span>〜</span>
                    <Datepicker class="datepicker" format="yyyy-MM-dd" v-model="productsAndRates.days.endday"
                        :disabled-dates="disabledDates" :language="ja" placeholder="終了日" />
                </div>
                <transition name="fade">
                    <div class="errorBalloon" v-if="errorMessage.period !== ''">
                        <p>{{ errorMessage.period }}</p>
                    </div>
                </transition>
                <transition name="fade">
                    <div class="errorBalloon" v-if="errorMessage.rate !== ''">
                        <p>{{ errorMessage.rate }}</p>
                    </div>
                </transition>
                <transition name="fade">
                    <div class="errorBalloon" v-if="errorMessage.integer !== ''">
                        <p>{{ errorMessage.integer }}</p>
                    </div>
                </transition>
                <div v-for="(product, productId, index) in this.productsAndRates.products" :key="index">
                    <br>
                    <span class="dispAdMenu" :class="{ 'selected': modalShow == true }"
                        @click="showSelectProduct(productId, index)">
                        <span class="productName">{{ product.productName }}</span>
                    </span>
                    <span v-if="product.productName !== ''">
                        <input class="inputRate" :value="product.rate" v-on:input="product.rate = $event.target.value"
                            @change="decimalToInteger" type="number" step="1"><span>%</span>
                    </span>
                </div>
                <br>
                <span class="btn" @click="addProduct">商品追加</span>
            </div>

            <div class="connectionSetting">
                <div class="connectionSettingFooter">
                    <a class="btn connectionSubmitBtn" @click="update">更新</a>
                </div>
                <div>
                    <a class="btn deleteBtn" @click="openDeleteModal">削除</a>
                </div>
                <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
                    <DeleteModal @canceled="closeDeleteModal" @deleted="deleteAdCluster" />
                </modal>
            </div>
            <modal name="selectProduct" :draggable="false" :resizable="false" width="70%" height="80%"
                @closed="modalClosed">
                <ShowProduct @modalClosed="modalClosed" :value="selectedProductId"
                    :selectedProductAndRateIndex="selectedProductAndRateIndex" @selectProduct="updateProduct" />
            </modal>
            <vue-good-table class="table" :columns="table.columns" :rows="table.rows" :fixed-header="true"
                max-height="350px" />
        </div>
    </div>
</template>

<script>
import ShowProduct from './ShowProduct.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import DeleteModal from '../components/DeleteModal.vue'

export default {
    name: 'Prorate',
    components: {
        ShowProduct,
        Datepicker,
        DeleteModal
    },
    data() {
        return {
            modalShow: false,
            selectedProductId: null,
            ja: ja,
            adClusterName: '',
            adClusterUrl: '',
            selectedProductAndRateIndex: null,
            unSelectedProductCount: 0,
            errorMessage: { period: '', rate: '', integer: '' },
            yesterday: '',
            periodOptions: [],
            selectedPeriod: '期間',
            disabledDates: {
                from: null,
                to: new Date('2021-12-01')
            },
            productsAndRates: {
                days: {
                    'startday': null,  // DatepickerのvalueはDateオブジェクト
                    'endday': null     // DatepickerのvalueはDateオブジェクト
                },
                products: {}
            },
            table: {
                columns: [
                    {
                        label: '日付',
                        field: 'outputday',
                        type: 'date',
                        dateInputFormat: 'yyyy-mm-dd',
                        dateOutputFormat: 'yyyy-mm-dd',
                    },
                ],
                rows: []
            },
            submitData: {}
        }
    },
    props: {
        adClusterId: Number
    },
    created: function () {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/proportionRate?adClusterId=" + this.adClusterId)
            .then((res) => {
                this.adClusterName = res.data.item.name;
                this.adClusterUrl = res.data.item.url;
                if (res.data.outputdays.length === 0) {
                    this.periodOptions = [
                        { label: '全期間', period: 'allPeriod' },
                    ];
                } else {
                    this.periodOptions = [
                        { label: '全期間', period: 'allPeriod' },
                        { label: '特定期間', period: 'pastPeriod' },
                    ];
                }

                // レスポンスから this.productsAndRates・this.table を作成
                let columnField = [];
                let outputdayObject = {};
                let dateObject = new Date();
                dateObject.setDate(dateObject.getDate());
                dateObject.setHours(0, 0, 0, 0);
                this.disabledDates.from = dateObject;

                //按分率は昨日の分まで登録されている
                this.yesterday = dateObject.getFullYear() + '-' + (dateObject.getMonth() + 1) + '-' + (dateObject.getDate() - 1);

                Object.keys(res.data.outputdays).forEach((outputday) => {
                    let pushToTableRows = {};
                    pushToTableRows.outputday = outputday;
                    outputdayObject = new Date(outputday);
                    Object.keys(res.data.outputdays[outputday]).forEach((productId) => {
                        // res.data.outputdaysは必ず前日が最新日。前日の按分率をthis.productsAndRatesへ格納。
                        const outputdayString = outputdayObject.getFullYear() + '-' + (outputdayObject.getMonth() + 1) + '-' + (outputdayObject.getDate());
                        if (this.yesterday === outputdayString) {
                            // オブジェクト自動ソート防止
                            this.$set(this.productsAndRates.products, '_' + productId.toString(), {});
                            this.$set(this.productsAndRates.products['_' + productId.toString()], 'productName', res.data.outputdays[outputday][productId].productName);
                            this.$set(this.productsAndRates.products['_' + productId.toString()], 'rate', Math.round(res.data.outputdays[outputday][productId].rate * 100));
                        }
                        // 既に存在するカラムの商品ID配列（columnField） を作成
                        this.table.columns.forEach((column) => {
                            if (!columnField.includes(column.field)) {
                                columnField.push(column.field);
                            }
                        });
                        const index = columnField.indexOf('outputday');
                        columnField.splice(index, 1);

                        // 存在していない商品IDのカラムを追加
                        if (!(columnField.includes(productId))) {
                            this.table.columns.push({
                                label: res.data.outputdays[outputday][productId].productName,
                                field: productId,
                                tdClass: 'text-right',
                                // type: 'percentage'
                            });
                        }
                        pushToTableRows[productId] = Math.round(res.data.outputdays[outputday][productId].rate * 100) + '％';
                    });
                    this.table.rows.push(pushToTableRows);
                });

                this.$store.dispatch("loading", false);
            }).catch(() => {
                //
            })
    },
    methods: {
        showSelectProduct(productId, productAndRateIndex) {
            this.modalShow = true;
            this.selectedProductId = productId.substr(1) - 0;
            this.selectedProductAndRateIndex = productAndRateIndex;
            this.$modal.show('selectProduct');
        },
        updateProduct(selectProduct) {
            let index = 0;
            Object.keys(this.productsAndRates.products).forEach((productId) => {
                if (index == selectProduct.selectedProductAndRateIndex) {
                    this.$delete(this.productsAndRates.products, productId.toString());
                    // オブジェクト自動ソート防止
                    this.$set(this.productsAndRates.products, '_' + selectProduct.productId.toString(), {});
                    this.$set(this.productsAndRates.products['_' + selectProduct.productId.toString()], 'productName', selectProduct.productName);
                    this.$set(this.productsAndRates.products['_' + selectProduct.productId.toString()], 'rate', 0);
                }
                index++;
            });
            // 未入力の商品入力欄を下へ
            Object.keys(this.productsAndRates.products).forEach((productId) => {
                // 未選択商品の場合
                if (productId.match(/^_none.+/)) {
                    this.$delete(this.productsAndRates.products, productId);
                    this.$set(this.productsAndRates.products, productId, {});
                    this.$set(this.productsAndRates.products[productId], 'productName', '');
                    this.$set(this.productsAndRates.products[productId], 'rate', 0);
                }
            });
        },
        decimalToInteger() {
            // 按分率は小数点不可（自動切り捨て）
            Object.keys(this.productsAndRates.products).forEach((productId) => {
                this.productsAndRates.products[productId].rate = Math.floor(this.productsAndRates.products[productId].rate);
            });
        },
        addProduct() {
            this.$set(this.productsAndRates.products, '_none' + this.unSelectedProductCount, {});
            this.$set(this.productsAndRates.products['_none' + this.unSelectedProductCount], 'productName', '');
            this.$set(this.productsAndRates.products['_none' + this.unSelectedProductCount], 'rate', 0);
            this.unSelectedProductCount++;
        },
        modalClosed() {
            this.modalShow = false
            this.selectedProductName = '';
            this.$modal.hide('selectProduct');
        },
        // 更新ボタン
        async update() {
            this.$store.dispatch("loading", true);
            const errorFlg = await this.updateRates();
            if (errorFlg == 0) {
                await this.updateAdCluster();
            }
            this.$store.dispatch("loading", false);
        },
        //按分率登録
        async updateRates() {
            this.$set(this.submitData, 'products', {});
            let sumRate = 0;
            Object.keys(this.productsAndRates.products).forEach((productId) => {
                // 未選択商品以外
                if (!productId.match(/^_none.+/)) {
                    sumRate += this.productsAndRates.products[productId].rate;
                    if (this.productsAndRates.products[productId].rate < 0) {
                        this.$set(this.errorMessage, 'integer', '割合は正の値を入力してください。');
                    } else {
                        this.$set(this.errorMessage, 'integer', '');
                    }
                    this.$set(this.submitData.products, productId.split('_')[1], this.productsAndRates.products[productId].rate / 100);
                }
            });
            if (sumRate !== 100) {
                this.$set(this.errorMessage, 'rate', '割合の合計を100%にしてください。');
            } else {
                this.$set(this.errorMessage, 'rate', '');
            }

            if (this.productsAndRates.days.startday === null || this.productsAndRates.days.endday === null) {
                this.$set(this.errorMessage, 'period', '期間を選択してください。');
            } else {
                this.$set(this.errorMessage, 'period', '');
            }

            if (this.errorMessage.rate !== '' || this.errorMessage.period !== '' || this.errorMessage.integer !== '') {
                return 1;
            }

            this.$set(this.submitData, 'adClusterId', this.adClusterId);
            Object.keys(this.productsAndRates.days).forEach((day) => {
                this.$set(this.submitData, day, this.productsAndRates.days[day].getFullYear() + '-' + (this.productsAndRates.days[day].getMonth() + 1) + '-' + (this.productsAndRates.days[day].getDate()));
            });

            await this.axios.put("api/proportionRate", this.submitData).then(() => {
            }).catch(() => {
                //
            })

            return 0;
        },
        reverseDays() {
            if ((this.productsAndRates.days.startday !== null && this.productsAndRates.days.endday !== null) &&
                (this.productsAndRates.days.startday > this.productsAndRates.days.endday)) {
                [this.productsAndRates.days.startday, this.productsAndRates.days.endday] = [this.productsAndRates.days.endday, this.productsAndRates.days.startday];
            }
        },
        //クラスタ一覧を更新
        //このモーダルを閉じる
        async updateAdCluster() {
            var url = "/api/adClusters/" + this.adClusterId;
            var data = {
                "adClusterName": this.adClusterName,
                "adClusterUrl": this.adClusterUrl,
            }
            await this.axios.put(url, data).then(() => {
                this.$emit('updated');
                this.modalShow = false
                this.$modal.hide("Prorate")
            }).catch(() => {
            })
        },
        //クラスタ削除
        deleteAdCluster() {
            var url = "/api/adClusters/" + this.adClusterId;
            this.$store.dispatch("loading", true);
            this.axios.delete(url).then(() => {
                this.$emit('updated');

                this.modalShow = false
                this.$modal.hide("Prorate")
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    },
    watch: {
        selectedPeriod: function () {
            if (this.selectedPeriod === 'allPeriod') {
                let dateObject = new Date();
                dateObject.setDate(dateObject.getDate() - 1);
                this.productsAndRates.days.startday = new Date('2021-12-01');
                this.productsAndRates.days.endday = dateObject;
            } else if (this.selectedPeriod === 'pastPeriod') {
                this.productsAndRates.days.startday = null;
                this.productsAndRates.days.endday = null;
            } else {
                // プルダウンが選択されていないため this.productsAndRates.days の値は変化なし。
            }
        },
        'productsAndRates.days.startday': function () {
            this.reverseDays();
        },
        'productsAndRates.days.endday': function () {
            this.reverseDays();
        }
    }
}
</script>

<style scoped lang="sass">
#connectionContainer
    height: 100%
    margin: 15px 15px 0 20px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        font-size: 1.5rem
        height: 20%
        padding: 5px
        text-align: center
        .connectionInfo
            overflow-wrap: break-word
            width: 40%
            color: $grayColor
            flex: 1 1 100%
            .adClusterInputText
                width: 300px
                padding: 10px
                text-align: left
                &:focus
                    outline: 2px solid $mainColor
            .connectionInfoLine
                color: $grayColor
                font-size: 1.5rem
                margin-bottom: 25px
                text-align: left
                span
                    display: inline-block
                .connectionInfoItem
                    min-width: 130px
                .connectionInfoValue
                    font-weight: 700
        .info_icon
            padding: 10px
        .closeBtn
            border: 1px solid $whiteColor
            display: block
            flex: 1 0 auto
            font-size: 1.7rem
            height: 40px
            margin-left: 5px
            padding: 10px 10px
            width: 40px
            &:hover
                border: 1px solid $mainColor
    .dispRightMenu
        background: #f5f5f5
        flex: 1 0 auto
        max-height: 380px
        .select
            display: block
            width: 250px
        .errorBalloon
            padding: 4px
            text-align: left
            width: 30%
            margin: 8px
            &:before
                border: 5px solid transparent
                border-top: 10px solid #FDD
                left: 12px
                margin-left: 0px
                position: absolute
                bottom: -15px
            &:after
                border: 7px solid transparent
                border-top: 12px solid #ff0000
                left: 10px
                margin-left: 0px
                position: absolute
                bottom: -19px
        .fade-enter-active, .fade-leave-active
                transition: opacity 0.3s
        .fade-enter, .fade-leave-to
            opacity: 0
        .datepicker
            display: inline-block
        .vs__dropdown-menu
            min-width: 120px !important
        span
            display: inline-block
            text-align: left
            vertical-align: middle
        .dispAdMenu
            background: $mainColor
            color: $whiteColor
            cursor: pointer
            overflow: hidden
            height: 24px;
            padding: 7px
            position: relative
            width: 250px
            &::before
                background: $whiteColor
                top: 0
                content: ''
                height: 100%
                left: 0
                position: absolute
                transform: translate(0%, 100%)
                transition: all .3s ease-in-out
                width: 100%
            &::after
                background: $whiteColor
                content: ''
                height: 16px
                position: absolute
                right: 8px
                transform: rotate(45deg)
                transition: all .3s ease-in-out
                top: 6px
                width: 16px
            &:hover
                color: $grayColor
                &::before
                    transform: translate(0%, 0%)
                &::after
                    background: $grayColor
                    transform: rotate(225deg)
            .productName
                display: block
                position: relative
        .selected
            background: $whiteColor
            color: $grayColor
            &::before
                transform: translate(0%, 0%)
            &::after
                background: $grayColor
                transform: rotate(225deg)
        .inputRate
            margin-left: 8px
            width: 100px
    .connectionSetting
        color: $grayColor
        display: flex
        flex-direction: column
        font-size: 1.5rem
        height: 70%
        padding: 5px
        .connectionSettingFooter
            display: flex
            flex: 0 1 0%
            justify-content: center
            margin-top: 8px
            .connectionSubmitBtn
                border: 1px solid $mainColor
                padding: 5px
                width: 100px
                &:hover
                    border: 1px solid $mainColor
    .table
        position: absolute
        bottom: 10px
        width: 97%
        .text-right
            text-align: right;
</style>
